import type { BackstageUserIdentity } from '@backstage/frontend-plugin-api';

function removeDuplicates(entityRefs: string[]): string[] {
  return Array.from(new Set(entityRefs));
}

export function getOwnershipEntityRefs(identity: BackstageUserIdentity): string[] {
  const refs = identity.ownershipEntityRefs.length
    ? identity.ownershipEntityRefs
    : [identity.userEntityRef];

  return removeDuplicates(refs);
}

const ALLOWED_ENTITY_KINDS = ['component', 'system'];

export function buildOwnedEntityFilters(ownershipEntityRefs: string[]) {
  return ownershipEntityRefs.map(entityRef => ({
    'relations.ownedBy': entityRef,
    kind: ALLOWED_ENTITY_KINDS,
  }));
}
